import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface RemoveParticipantTypeDialogProps {
  type?: string;
  isOpen: boolean;
  onSubmit: () => void;
  onOpenChange: (nextOpenState: boolean) => void;
}

export function RemoveParticipantTypeDialog({
  type,
  isOpen,
  onSubmit,
  onOpenChange,
}: RemoveParticipantTypeDialogProps) {
  const handleSubmit = (event: React.SyntheticEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    onSubmit();
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Remove participant type "{type}"?</AlertDialogTitle>
          <AlertDialogDescription>
            This participant type is linked to existing participants. Deleting
            it will permanently remove them from the event. Change their type if
            you wish to keep them.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction
            type="button"
            onClick={handleSubmit}
            className="text-destructive border-destructive hover:text-destructive"
            data-testid="proceed-button"
          >
            Proceed
          </AlertDialogAction>
          <AlertDialogCancel type="button" data-testid="cancel-button">
            Cancel
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
